import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass/styled-components';
import { Loader, Button } from '@getro/rombo';
import { ConnectionPathCard } from './ConnectionPathCard';
import { useConnectionPaths } from './hooks/useConnectionPaths';
import { trackEvent } from '../../../helpers/analytics';
import { getContactDisplayName } from '../../../helpers/getContactDisplayName';

export const ConnectionPaths = ({ network, contact }) => {
  const {
    data = [],
    isLoading,
    isSuccess,
    showAll,
    setShowAll,
    itemsToRender,
    hasMore,
  } = useConnectionPaths({ contact });

  useEffect(() => {
    if (isSuccess) {
      trackEvent('contacts:connection_paths:view', {
        contactId: contact.id,
        collectionId: network?.id,
        connectionPathsCount: data.length,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  if (isLoading) {
    return (
      <Flex alignItems="center" justifyContent="center" py="24px">
        <Loader />
      </Flex>
    );
  }

  if (!data || data.length === 0) {
    return (
      <Text fontSize="14px" color="text.main">
        There are no signals that suggest your team can reach {getContactDisplayName(contact, 'this contact')}.
      </Text>
    );
  }

  return (
    <Flex sx={{ flexDirection: 'column', gap: '12px' }}>
      <Box>
        <Flex sx={{ flexDirection: 'column', gap: '12px' }}>
          {itemsToRender.map((item) => (
            <ConnectionPathCard key={item.id} network={network} item={item} />
          ))}
        </Flex>
      </Box>

      {hasMore && (
        <Box textAlign="center" pt="16px">
          {!showAll && (
            <Button variant="secondary" size="small" onClick={() => setShowAll(true)}>
              View more
            </Button>
          )}
        </Box>
      )}
    </Flex>
  );
};

ConnectionPaths.propTypes = {
  contact: PropTypes.object.isRequired,
  network: PropTypes.object.isRequired,
};
